import type { Dayjs } from "dayjs";
import type { IBatteryHealth, IBatteryHealthDto, IBatteryVoltageReading } from "./IBatteryHealth";
import dayjs from "dayjs";

export class BatteryHealth implements IBatteryHealth
{

    currentVoltage: number = 0;
    utcDateLastReading?: Dayjs;
    batteryVoltageReadings: IBatteryVoltageReading[] = [];
    sparkline: number[] = [];
    hasIssue: boolean = false;
    hasData: boolean = false;
    minVoltage: number = 0;
    maxVoltage: number = 0;

    constructor( model: IBatteryHealthDto )
    {

        if( model == null ) return;
        
        this.batteryVoltageReadings = model.batteryVoltageReadings;
        this.sparkline = model.batteryVoltageReadings.map( ( reading ) => reading.voltage );
        this.currentVoltage = this.sparkline.length == 0 ? 0 : this.sparkline[ this.sparkline.length - 1 ];
        this.utcDateLastReading = model.batteryVoltageReadings.length == 0 ? undefined : dayjs( model.batteryVoltageReadings[ model.batteryVoltageReadings.length - 1 ].readingTimestamp );
        this.hasData = this.sparkline.length > 0;

        this.minVoltage = Math.min( ...this.sparkline );
        this.maxVoltage = Math.max( ...this.sparkline );

    }

}